import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import Toast from './components/Toast';
import { IconSprite } from './components/Icon';

export default function App() {
  return (
    <BrowserRouter>
      <IconSprite />
      <AppRoutes />
      <Toast />
    </BrowserRouter>
  );
}
